<template>
	<div>
		<div class="actDiv" title="扣费统计">
			<label>小区</label>
			<a-select style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区"
				 label-in-value option-filter-prop="children"  :filter-option="filterOption" show-search @change="queryData" allowClear>
				<a-select-option v-for="(item,index) in searchneighborList" :key="item.pId" :value="item.pId">
					{{item.neighborName}}
				</a-select-option>
			</a-select>
			<a-button size="small" icon="export" :disabled="dataList.length==0"  @click="downloadExcel" style="margin: 0 0.625rem;" :loading="exportLoading">导出Excel</a-button>
		</div>	
		<vxe-table  align="center" :data="dataList"  border height="600"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="pid"  >
							<vxe-table-column type="seq" width="60"></vxe-table-column>
							<vxe-table-column title="用户号" field="CustomerNum" ></vxe-table-column>
							<vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
							<vxe-table-column title="用户手机" field="CustomerMobile"></vxe-table-column>
							<vxe-table-column title="所属小区" field="NeighborName"></vxe-table-column>
							<vxe-table-column title="用户余额" field="CustomerBalance"></vxe-table-column>
							<vxe-table-column title="减免数量" field="minus_count"></vxe-table-column>
							<vxe-table-column title="减免时间" field="create_time" :formatter="getTimeFormatter"></vxe-table-column>
							<vxe-table-column title="操作人" field="AdminName"></vxe-table-column>
		</vxe-table>	
	</div>
</template>

<script>
	export default {
		data(){
			return {
				searchneighborList:[],
				theNeighbor:undefined,
				exportLoading:false,
				dataList:[],
			}
		},
		methods:{
			queryNeighbors: function() {
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.searchneighborList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			queryData:function(){
				let url = this.Api.getLastUrl(this.Api.STATIS_MINUS_LIST_URL);
				let param = null;
				if(this.theNeighbor!=undefined){
					param = {
						neighborId:this.theNeighbor.key
					}
				}
				this.Api.fetchPostWithForm(url,param).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.dataList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			downloadExcel:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_MINUS_EXPORT_URL);
				let param = null;
				if(this.theNeighbor!=undefined){
					param = {
						neighborId:this.theNeighbor.key
					}
				}
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = '减免统计.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
		},
		created() {
			this.queryNeighbors();
			this.queryData();
		},
	}
</script>

<style>
</style>
